import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <section className="chapter">
      <p className="chapter__title">
        Datarwe: The Analytics of Millions Driving Better Care for Individuals
      </p>
      <p className="chapter__paragraph">
        The healthcare industry often looks to generate the best possible outcomes at the population
        level. But when data is highly regulated for privacy reasons and not often shared between
        hospitals, it can be difficult to have that data impact individual outcomes including the
        improved care of your loved one.
      </p>
      <p className="chapter__paragraph">
        <a
          href="https://datarwe.com/"
          target="_blank"
          rel="noreferrer"
          className="chapter__paragraph__link"
        >
          Datarwe
        </a>
        , a clinical Data-as-a-Service provider based in Australia, is on a mission to combine
        anonymized patient data with advanced analytics to give clinicians, hospitals, and public
        health authorities the ability to make evidence-based changes in healthcare practices that
        could yield better outcomes at the individual patient level.
      </p>
      <p className="chapter__paragraph">
        “Overall, we are working to achieve the dream of personalized medicine,” says Steve
        Woodyatt, Datarwe’s CEO. “If you went to the doctor, the idea is that they would know
        exactly what treatment to give you, not based on general population studies, but according
        to what has worked for people who are very similar to you that had a similar disease
        progression.”
      </p>
    </section>
  );
}

export default Chapter4;
